// Adapted from pingdotgg/t3code (MIT), apps/web/src/components/MorphIcon.tsx at 7202ba666.
// Upstream morphs `lucide` path data with the `morphicons` package. Amoreg ships
// `lucide-react` only, so the new icon replaces the old one with a short turn
// and grow (`animate-icon-morph-in`) instead of a path morph, and stays still
// for people who ask for reduced motion.
import type { LucideIcon } from "lucide-react";

import { cn } from "~/lib/utils";

/** Renders `icon` and animates the swap whenever a different icon is passed. */
export function MorphIcon({ icon: Icon, className }: { icon: LucideIcon; className?: string }) {
  return (
    <span
      // A new key remounts the span, which replays the entry animation.
      key={Icon.displayName ?? "icon"}
      className="inline-flex motion-safe:animate-icon-morph-in"
      data-morph-icon={Icon.displayName ?? "icon"}
      aria-hidden="true"
    >
      <Icon className={cn("shrink-0", className)} aria-hidden="true" />
    </span>
  );
}
